import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { MyContext } from '../context';
import { Header, SubHeader, ComingSoon, Images } from '../components';
import { Helmet } from "react-helmet";
import MetaData from "../helper/MetaData";

export default class LiveScoreWidgets extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }


    render() {

        const HeaderOption = {
            menu: true,
            Notification: true,
            Logo: true,
        }

        return (
            <MyContext.Consumer>
                {(context) => (
                    <div className="web-container lobby-web-container">
                        <Helmet titleTemplate={`${MetaData.template} | %s`}>
                            <title>{MetaData.lobby.title}</title>
                            <meta name="description" content={MetaData.lobby.description} />
                            <meta name="keywords" content={MetaData.lobby.keywords}></meta>
                        </Helmet>
                        <Header {...this.props} HeaderOption={HeaderOption} />
                        <div >

                            <Row>
                                <Col sm={12}>
                                    <SubHeader Title="Scores" ImgShown={Images.HEADER_BG} BannerImage="" AddClassName="page-inner-header-sm" />
                                    <ComingSoon />
                                </Col>
                            </Row>

                        </div>
                    </div>
                )}
            </MyContext.Consumer>
        )
    }

}
